import API from '../interceptors/Api';

const baseUrl = '/strategic-overview';

export const getInvestmentExpiration = (params) => API.get(`${baseUrl}/investments-expiration`, { params });

export const getFutureCash = (params) => API.get(`${baseUrl}/future-cash`, { params });

export const getInvestments = (params) => API.get(`${baseUrl}/investments`, { params });

export const getTotalPosition = (params) => API.get(`${baseUrl}/totals`, { params });

export const getIndicators = (params) => API.get(`${baseUrl}/indicators`, { params });

export const createInvestmentSimulation = (data) => API.post(`${baseUrl}/indicators`, data);

export const getApplicationRates = () => API.get(`${baseUrl}/application-rates`);

export const getHolidays = (params) => API.get('/holidays', { params });
